import { Injectable } from '@angular/core';

export interface IOutboundKpisModel {
  name: string;
  description: string;
  isDefault: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class OutboundKpisService {
  private outboundKpis: IOutboundKpisModel[];

  constructor() {
    this.outboundKpis = [
      {
        name: 'Outbound Records',
        description: 'campaignSize',
        isDefault: true,
      },
      {
        name: 'Live Connections',
        description: 'liveConnections',
        isDefault: false,
      },
      {
        name: 'Appointments',
        description: 'appointments',
        isDefault: false,
      },
      {
        name: 'Messages',
        description: 'voicemails',
        isDefault: false,
      },
    ];
  }

  getKpis(): IOutboundKpisModel[] {
    return this.outboundKpis;
  }
}
